import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import {
  Select,
  Row,
  Col,
  Button,
  DatePicker,
  Checkbox,
  Modal,
  Input,
  InputNumber
} from 'hljd'
import ImgGallery from '@common/ImgGallery'
import { observer } from 'mobx-react'
import store from '../store'
import storeUp from '../../store'
import { toJS } from 'mobx'
import moment from 'moment'
import style from './style.module.less'
const CheckboxGroup = Checkbox.Group
const options = [{ label: '午市', value: '1' }, { label: '晚市', value: '2' }]
const Item = Form.Item
const Option = Select.Option
const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 15 }
}

@observer
export default class extends Component {
  render() {
    const {
      form: {
        wedding_day,
        tables_num,
        price,
        other_fee,
        eat_time,
        deposit_money,
        contract_money,
        backup_table_num,
        hotel_hall_id
      }
    } = store

    let hall = <Option value="">暂无</Option>
    if (storeUp.hallData) {
      hall = storeUp.hallData.map(v => {
        let _obj = (
          <Option key={v.id} value={String(v.id)}>
            {v.name}
          </Option>
        )
        return _obj
      })
    }

    return (
      <Modal
        visible={store.visible}
        footer={null}
        onCancel={store.handleCancel}
      >
        <div className={style.form}>
          <Form>
            <Item {...layout} />
            <Item {...layout} required label="婚期">
              <DatePicker
                value={wedding_day ? toJS(moment(wedding_day)) : ''}
                format="YYYY-MM-DD"
                onChange={store.setDate}
              />
            </Item>
            <Item {...layout} required label="婚宴酒店">
              {storeUp.orderInfo.hotel}
            </Item>
            <Item {...layout} required label="婚宴场地">
              <Select
                value={String(hotel_hall_id)}
                onChange={store.setHall}
                placeholder="请选择"
              >
                {hall}
              </Select>
            </Item>
            <Item {...layout} required label="市别">
              <CheckboxGroup
                value={eat_time ? eat_time.split(',') : []}
                options={options}
                onChange={store.setCol}
              />
            </Item>
            <Row>
              <Col span={12}>
                <Item
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 11 }}
                  required
                  label="桌数"
                >
                  <Input
                    value={tables_num}
                    onChange={store.setTable}
                    style={{ width: 80 }}
                  />
                  <i style={{ marginLeft: 10 }}>桌</i>
                </Item>
              </Col>
              <Col span={12}>
                <Item
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 11 }}
                  label="备桌"
                >
                  <Input
                    value={backup_table_num}
                    onChange={store.setTable_backUp}
                    style={{ width: 80 }}
                  />
                  <i style={{ marginLeft: 10 }}>桌</i>
                </Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Item
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 11 }}
                  required
                  label="餐标"
                >
                  <InputNumber
                    value={price}
                    onChange={store.setTablePrice}
                    style={{ width: 80 }}
                    min={0}
                    step={0.01}
                  />
                  <i style={{ marginLeft: 10 }}>元</i>
                </Item>
              </Col>
              <Col span={12}>
                <Item
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 11 }}
                  label="其他费用"
                >
                  <InputNumber
                    value={other_fee}
                    onChange={store.setHPrice_other}
                    style={{ width: 80 }}
                    min={0}
                    step={0.01}
                  />
                  <i style={{ marginLeft: 10 }}>元</i>
                </Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Item
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 11 }}
                  required
                  label="婚宴总价"
                >
                  <InputNumber
                    value={contract_money}
                    onChange={store.setHPrice}
                    style={{ width: 80 }}
                    min={0}
                    step={0.01}
                  />
                  <i style={{ marginLeft: 10 }}>元</i>
                </Item>
              </Col>
              <Col span={12}>
                <Item
                  labelCol={{ span: 10 }}
                  wrapperCol={{ span: 11 }}
                  required
                  label="已收定金"
                >
                  <InputNumber
                    value={deposit_money}
                    onChange={store.setHdeposit}
                    style={{ width: 80 }}
                    min={0}
                    step={0.01}
                  />
                  <i style={{ marginLeft: 10 }}>元</i>
                </Item>
              </Col>
            </Row>
            <Item
              labelCol={{ span: 5 }}
              wrapperCol={{ span: 18 }}
              label="凭证上传"
            >
              <em>上传有效凭证有助于通过审核，最多上传5张</em>
              <ImgGallery
                keyField={'img'}
                max={5}
                onRemove={store.removeImg}
                multiple={true}
                onOk={store.upImg}
                imgList={store.imgs}
              />
            </Item>
          </Form>
          <div style={{ marginBottom: 30, textAlign: 'center' }}>
            <Button
              onClick={store.sendForm}
              style={{ marginRight: 15, width: 120 }}
              type="primary"
            >
              提交审核
            </Button>
            <Button onClick={store.handleCancel} style={{ width: 120 }}>
              取消
            </Button>
          </div>
        </div>
      </Modal>
    )
  }
}
